<template>
	<ResponsiveContainer>
		<BaseHeading type="h6" class="mt-10 md:mb-3 text-center text-base text-dj-grey">
			{{ $t(`logos.title.${region}`) }}
		</BaseHeading>
		<div
			class="block sm:flex flex-wrap items-center justify-center md:justify-between text-center max-w-[100%] sm:max-w-[680px] lg:max-w-[1400px] mx-auto mb-10 whitespace-nowrap sm:whitespace-normal overflow-x-auto"
		>
			<template v-if="region == 'HU'">
				<img
					class="inline-block m-2 w-[109px] h-[37px] sm:w-[218px] sm:h-[74px]"
					src="https://res.cloudinary.com/djbs/image/upload/v1655965062/content/DreamJobs/Graphics/logo_biotechusa.png"
					alt="BioTech USA"
				/>
				<img
					class="inline-block m-2 w-[76px] h-[37px] sm:w-[153px] sm:h-[74px]"
					src="https://res.cloudinary.com/djbs/image/upload/v1655965062/content/DreamJobs/Graphics/logo_wolt.png"
					alt="Wolt"
				/>
				<img
					class="inline-block m-2 w-[82px] h-[48px] sm:w-[173px] sm:h-[97px]"
					src="https://res.cloudinary.com/djbs/image/upload/v1655965062/content/DreamJobs/Graphics/logo_decathlon.png"
					alt="DECATHLON Magyarország"
				/>
				<img
					class="inline-block m-2 w-[82px] h-[32px] sm:w-[162px] sm:h-[64px]"
					src="https://res.cloudinary.com/djbs/image/upload/v1655965062/content/DreamJobs/Graphics/logo_auchan.png"
					alt="iAuchan Magyarország"
				/>
				<img
					class="inline-block m-2 w-[120px] h-[28px] sm:w-[239px] sm:h-[55px]"
					src="https://res.cloudinary.com/djbs/image/upload/v1655965062/content/DreamJobs/Graphics/logo_praktiker.png"
					alt="Praktiker Kft."
				/>
				<img
					class="inline-block m-2 w-[57px] h-[38px] sm:w-[113px] sm:h-[75px]"
					src="https://res.cloudinary.com/djbs/image/upload/v1655965062/content/DreamJobs/Graphics/logo_drogeriemarkt.png"
					alt="dm Magyarország"
				/>
			</template>
			<template v-if="region == 'RO'">
				<img
					class="inline-block m-2 w-[80px]"
					src="https://res.cloudinary.com/djbs/image/upload/v1674052383/content/DreamJobs/Graphics/logo_bibasroup.jpg"
					alt="Bibas Group"
				/>
				<img
					class="inline-block m-2 w-[80px]"
					src="https://res.cloudinary.com/djbs/image/upload/v1674052382/content/DreamJobs/Graphics/logo_nobilacasa.png"
					alt="Nobila Casa"
				/>
				<img
					class="inline-block m-2 w-[80px]"
					src="https://res.cloudinary.com/djbs/image/upload/v1674052382/content/DreamJobs/Graphics/logo_minicrmromania.png"
					alt="MiniCRM Romania"
				/>
				<img
					class="inline-block m-2 w-[80px]"
					src="https://res.cloudinary.com/djbs/image/upload/v1674052383/content/DreamJobs/Graphics/logo_flashnet.png"
					alt="FLASHNET"
				/>
				<img
					class="inline-block m-2 w-[80px]"
					src="https://res.cloudinary.com/djbs/image/upload/v1674052382/content/DreamJobs/Graphics/logo_enetixsoftware.png"
					alt="Enetix Software"
				/>
				<img
					class="inline-block m-2 w-[80px]"
					src="https://res.cloudinary.com/djbs/image/upload/v1674052382/content/DreamJobs/Graphics/logo_combridge.png"
					alt="Combridge"
				/>
				<img
					class="inline-block m-2 w-[80px]"
					src="https://res.cloudinary.com/djbs/image/upload/v1674052382/content/DreamJobs/Graphics/logo_melindainstal.png"
					alt="Melinda Instal"
				/>
				<img
					class="inline-block m-2 w-[80px]"
					src="https://res.cloudinary.com/djbs/image/upload/v1674052382/content/DreamJobs/Graphics/logo_septimiaresort.png"
					alt="Septimia Resort"
				/>
				<img
					class="inline-block m-2 w-[80px]"
					src="https://res.cloudinary.com/djbs/image/upload/v1674052382/content/DreamJobs/Graphics/logo_ecotinyhouse.png"
					alt="Eco Tiny House"
				/>
				<img
					class="inline-block m-2 w-[80px]"
					src="https://res.cloudinary.com/djbs/image/upload/v1674052382/content/DreamJobs/Graphics/logo_secoplanbuildingsystems.png"
					alt="SecoPlan Building Systems"
				/>
				<img
					class="inline-block m-2 w-[80px]"
					src="https://res.cloudinary.com/djbs/image/upload/v1674052382/content/DreamJobs/Graphics/logo_balvanyosresort.png"
					alt="Balvanyos Resort"
				/>
			</template>
		</div>
	</ResponsiveContainer>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useI18n } from "vue-i18n";

export default defineComponent({
	name: "Logos",
	setup() {
		const { locale } = useI18n({
			useScope: "global",
		});

		const region = ref("HU");

		onMounted(() => {
			region.value = useRegion.getCurrentRegion().code;
		});

		return {
			locale,
			region,
		};
	},
});
</script>
